import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  AccessDetail, useSecureAccess, revokeSecureAccess, expireSecureAccess,
  humanizeSecureAccessError, SECURE_ACCESS_ROOT,
} from './olivium/secure-access'

/**
 * Secure-access detail route wrapper (PHASE_2L).
 *   /square/command-center/olivium/secure-access/:accessId
 *
 * Finds the code in the real list (no plaintext/hash), and performs real,
 * audited revoke/expire. A failed action is surfaced (never a silent no-op).
 */
export default function SquareCodeSecureAccessDetailRoute() {
  const navigate = useNavigate()
  const { accessId } = useParams<{ accessId: string }>()
  const s = useSecureAccess()
  const [mutationError, setMutationError] = useState<string | null>(null)
  const code = s.codes.find((c) => c.id === accessId) || null
  const notFound = !s.loading && !s.authRequired && !s.forbidden && !s.error && !code

  const after = (p: Promise<unknown>) =>
    p.then(() => { setMutationError(null); return s.reload() },
      (e) => { setMutationError(humanizeSecureAccessError(e)); return s.reload() })

  return (
    <AccessDetail
      code={code}
      loading={s.loading}
      error={s.error}
      authRequired={s.authRequired}
      forbidden={s.forbidden}
      notFound={notFound}
      mutationError={mutationError}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenHub={() => navigate(SECURE_ACCESS_ROOT)}
      onRevoke={() => code && after(revokeSecureAccess(code.id, 'operator revoke'))}
      onExpire={() => code && after(expireSecureAccess(code.id))}
      onOpenDestination={(url) => navigate(url)}
    />
  )
}
